import { httpClient } from "../../httpClient";

type Data = any;

const webapi = "/api/v1/subcategoryapprovers/bysubcategory";

export async function getSubCategoryApproverBySubCategoryId(
  id: number
): Promise<any> {
  try {
    const { data } = await httpClient.get(`webapi/${id}`);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export const subcategoryapprover = {
  getSubCategoryApproverBySubCategoryId,
};
